export default "__VITE_ASSET__eBwM8$0Y__"